import editorExtensions from "@/components/FpEditor/services/editorExtensions";
import { EditorView } from "@tiptap/pm/view";
import { EditorContent, useEditor } from "@tiptap/react";
import React, { useEffect } from "react";

const TipTapViewer = ({ htmlContent }: { htmlContent: string }) => {
  const editor = useEditor({
    extensions: editorExtensions,
    content: "",
    editable: false,
    editorProps: {
      attributes: {
        class:
          "outline-none preserve-default-styles text-[14px] focus:outline-none min-h-[200px] pb-[0px] tiptap-editor text-[#27272A] px-4 w-full",
      },

      handleScrollToSelection: function (view: EditorView) {
        return false;
      },
    },

    onFocus: ({ editor, event }) => {
      editor.view.dom.classList.add("editor-focused");
    },
    onBlur: ({ editor, event }) => {
      editor.view.dom.classList.remove("editor-focused");
    },
    onCreate({ editor }) {
      // editor.commands.insertContent(htmlContent);
    },
  });

  useEffect(() => {
    if (editor) {
      editor.commands.setContent("");
      editor.commands.insertContent(htmlContent);
    }
  }, [htmlContent, editor]);

  return (
    <div className="w-full">
      <EditorContent editor={editor} className="w-full max-width-override" />
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .max-width-override .ProseMirror > * {
              max-width: none !important;
            }
          `,
        }}
      />
    </div>
  );
};

export default TipTapViewer;
